<template>
  <div class="home">
    <Header />
    <div class="welcome_wrap">
      <p class="version">Version {{appVersion}}</p>
      <div class="fullbox"
           :style="{'width': window.width + 'px', 'height': windowHeight + 'px'}">
        <div class="fullbox_cont container">
          <div class="row">
            <div class="col-lg-12">
              <h2 class="text-center">{{$t('home.serviceTools')}}</h2>
              <div class="panel panel-default box_orange">
                <div class="panel-heading">
                  <span class="icon-sidebar_bike"
                        aria-hidden="true"></span>
                  <p class="text_panelBox">{{$t('home.connectBike')}}</p>
                </div>
                <div class="panel-body">
                  <!-- <p>{{$t('home.quicklyAccess')}}</p> -->
                  <ol class="list_connectYourBike">
                    <li>{{$t('home.connectDongle')}}</li>
                    <li>{{$t('home.pressConnect')}}</li>
                  </ol>
                  <p class="text-center">
                    <router-link class="btn btn_maincolor btn_longer"
                                 to="/connect"
                                 role="button">{{$t('home.connect')}}</router-link>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="panel panel-default box_grey">
                <div class="panel-heading title_twoPanelBox">
                  <div class="text_panelBox">
                    <span class="icon_svgBg icon_nameDownload"></span>
                    <div class="text_childPanelBox">
                      <h5>Message Gateway</h5>
                      <p :data-title="$t('home.currentVersion')">{{CurrentVersion}}</p>
                      <p :data-title="$t('home.latestVersion')">{{strMGNewVer}}</p>
                    </div>
                  </div>
                  <div class="text_panelBox">
                    <span class="icon_svgBg icon_nameDongle"></span>
                    <div class="text_childPanelBox">
                      <h5>Dongle 1.0</h5>
                      <p :data-title="$t('home.currentVersion')">{{DongleCurrentVer}}</p>
                      <p :data-title="$t('home.latestVersion')">{{strDongleNewVer}}</p>
                    </div>
                  </div>
                </div>
                <div class="panel-body">
                  <p>{{$t('home.downloadVersion')}}</p>
                  <ol class="list_mgNoteList" :data-title="$t('home.pleaseNote')">
                    <li>{{$t('home.downloadParagraph1')}}</li>
                    <li>{{$t('home.downloadParagraph2')}}</li>
                    <li>{{$t('home.downloadParagraph3')}}</li>
                  </ol>
                  <p class="text-center mt30">
                    <a class="btn btn_maincolor btn_longer"
                       :href="getMGUrl(onlineMGUrl)"
                       role="button">QwicBicycleLink.exe (v{{strMGNewVer}})</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="panel panel-default box_grey">
                <div class="panel-heading">
                  <span class="icon_svgBg icon_nameUserName"></span>
                  <p class="text_panelBox">{{$t('home.getUserManual')}}</p>
                </div>
                <div class="panel-body">
                  <div class="table-responsive">
                    <table class="table table-condensed table_base">
                      <thead>
                        <tr>
                          <th>{{$t('home.language')}}</th>
                          <th>{{$t('home.pdf')}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Dutch</td>
                          <td>
                            <a href="https://qwic-fw.hylink.io/prod/QWIC+service+tool+2019.pdf"
                               target="_blank" download>
                              <span class="glyphicon glyphicon-save" aria-hidden="true"></span>
                              {{$t('home.download')}}
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>English</td>
                          <td>
                            <a href="javascript:;">
                              <span class="glyphicon glyphicon-save"
                                    aria-hidden="true"></span> {{$t('home.download')}}
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>German</td>
                          <td>
                            <a href="https://qwic-fw.hylink.io/prod/QWIC+service+tool+2019_DE.pdf"
                               target="_blank" download>
                              <span class="glyphicon glyphicon-save"
                                    aria-hidden="true"></span> {{$t('home.download')}}
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global  APPLICATION_VERSION */
import Header from './layouts/components/Header';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import * as connectBikeAPI from '@/api/connect-bike';
import { windowsResize } from '@/mixins/windows-resize';
import { websocketAutoUpdate } from '@/mixins/auto-update-api';
export default {
  name: 'home',
  components: {
    Header
  },
  mixins: [windowsResize, websocketAutoUpdate],
  data () {
    return {
      onlineMGUrl: '',
      CurrentVersion: '--',
      Newversion: '--',
      DongleCurrentVer: '--',
      DongleNewVer: '--',
      appVersion: APPLICATION_VERSION
    };
  },
  created () {
    this.$store.dispatch('bikeConnect/setBikeFlag', true);
    this.funcGetBikeLatestFWApi();
    this.funcGetMGVerApi();
  },
  computed: {
    windowHeight () {
      let oriHeight = this.window.height;
      if (oriHeight !== null) {
        oriHeight -= 60;
      }
      return oriHeight;
    },
    strDongleNewVer () {
      let DNGNewVer = this.DongleNewVer || '--';
      return DNGNewVer;
    },
    strMGNewVer () {
      let MGNewVer = this.Newversion || '--';
      return MGNewVer;
    }
  },
  methods: {
    async funcGetBikeLatestFWApi () {
      let partNoList = ['HD-040'];
      let message = { PartNoList: partNoList };
      const encryptData = funcEncryptData(message);
      const data = await connectBikeAPI.getBikeLatestFW(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      if (data.ErrorCode > 0) {
        return;
      }
      this.DongleNewVer = data.FwList[0].LatestFW;
      this.$store.dispatch('bikeConnect/setDGNewFWVer', this.DongleNewVer);
    },
    async funcGetMGVerApi () {
      let message = {};
      let fileName = [];
      const encryptData = funcEncryptData(message);
      const data = await connectBikeAPI.getMGVersion(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      this.Newversion = data.NewVersion;
      fileName = data.DownloadUrl.split('.io/');
      this.onlineMGUrl = fileName[1];
    },
    getMGUrl (val) {
      return 'https://qwic-fw.hylink.io/' + val;
    }
  }
};
</script>
<style lang="scss" scoped>
.fullbox {
  position: relative;
  overflow: hidden;
}
.version {
  color: $grey;
  @include rem(font-size, 2rem);
  margin-bottom: 0;
  position: fixed;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);

  @include nb-width {
    @include rem(font-size, 1.6rem);
    left: unset;
    right: 10px;
    transform: unset;
  }
}
</style>
